import { Snackbar, Alert, Stack, Fade } from '@mui/material';
import { useMemo, useState } from 'react';

type ToastItem = { key: string; label: string; open: boolean; severity?: 'info' | 'warning' | 'error' | 'success'; maxDuration?: number };

const ToastAlert = ({ label, open, severity, maxDuration }: ToastItem) => {

  // const visible = useMemo(() => {
  //   if (!open) return false;
  //   if (maxDuration && maxDuration > 0) {
  //     const start = Date.now();
  //     const interval = setInterval(() => {
  //       if (Date.now() - start >= maxDuration) {
  //         clearInterval(interval);
  //         return false;
  //       }
  //     }, 1000);
  //     return true;
  //   }
  //   return true;
  // }, [open, maxDuration]);
  const [visible, setVisible] = useState(open);
  useMemo(() => {
    let timeout;
    if (open) {
      setVisible(true);
      if (maxDuration && maxDuration > 0) {
        timeout = setTimeout(() => {
          setVisible(false);
        }, maxDuration);
      }
    } else {
      setVisible(false);
    }
    return () => {
      if (timeout) clearTimeout(timeout);
    };
  }, [open, maxDuration]);
  return (
    <Fade in={visible} timeout={{ enter: 500, exit: 300 }} unmountOnExit mountOnEnter>
      <Alert
        severity={severity || 'info'}
        variant="outlined"
        elevation={6}
        icon={false}
        sx={{
          px: 1,
          py: 0,
          borderRadius: 999,
          fontSize: 12,
          borderColor: 'divider',
          boxShadow: 1,
          alignItems: 'center',
          '& .MuiAlert-icon': {
            mr: 0.5,
            py: 0.5,
          },
          '& .MuiAlert-message': {
            px: 0,
            py: 0.5,
          },
        }}
      >
        {label}
      </Alert>
    </Fade>
  )
};  

export default function RefreshToasts({ items }: { items: ToastItem[] }) {
  const anyOpen = useMemo(() => items?.some((it) => it.open), [items]);
  return items ? (
    <Snackbar open={anyOpen} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} sx={{ mt: 6 }}>
      <Stack sx={{ flexDirection: 'column', gap: 0.4 }}>
        {items.map(({ key, ...rest }) => <ToastAlert key={key} {...rest} />)}
      </Stack>
    </Snackbar>
  ) : null;
}
